import React, { useCallback, useEffect, useRef, useState } from "react";
import "./DocumentViewer.css";
import searchIcon from "../../common/assets/images/Search.png";
import plusIcon from "../../common/assets/images/plus_icon.png";
import minsIcon from "../../common/assets/images/mins-icon.png";
import externalIcon from "../../common/assets/images/link-external.png";
import documentationIcon from "../../common/assets/images/documentation.png";
import {Accordion, Pagination, Card, Spinner } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { getDocumentViewerData, searchDocumentViewerData, setDocumentviewerPage, setDocumentviewerSearchValue, resetDocumentviewerSearchValue, setDocumentviewerEventKey, setDocumentviewerSelectedDocumentData, setEpisodeIdentifierTopassDocumentViewer, resetDocumentViewerError} from "./redux/DocumentViewerSlicer";
import LdsRoller from "../../utils/LdsRoller";
import { useDispatch, useSelector } from "react-redux";
import DOMPurify from 'dompurify';

const DocumentViewer = ({ episodeList }) => {
  const cardRefs = useRef([]);
  const location = useLocation();
  const dispatch = useDispatch();
  const currentScreen = sessionStorage.getItem("currentPage");
  // let selectedEpisodeIdentifier = null;
  // if (currentScreen === "episodeList") {
  let selectedEpisodeIdentifier = episodeList?.selectedEpisode?.episode_identifier;
  // } else if (currentScreen === "coderview" || currentScreen === "auditorPage") {
  // selectedEpisodeIdentifier = episodeList?.selectedEpisode?.medical_record_number;
  // }
  // const selectedEpisodeIdentifier = currentScreen === "episodeList" ? episodeList?.selectedEpisode?.episode_identifier : currentScreen === "coderview" || currentScreen === "auditorPage" ? episodeList?.selectedEpisode?.medical_record_number;
  const lastCodedEpisode = useSelector((state) => state.documentViewer);
  // const [episodeIdentifierTopassDocumentViewer, setEpisodeIdentifierTopassDocumentViewer] = useState("");
  // const { documentviewerCurrentPage } = useSelector((state) => state.documentViewer);
  const { documentViewerData, documentViewerDataLoader, documentViewerDataError } = useSelector((state) => state.documentViewer.documentViewer);
  // const { documentSearchValue, documentSearchValueLoading, documentSearchValueError } = useSelector((state) => state.documentViewer.documentViewerSearch);
  // const {documentviewerSearchValue} = useSelector((state) => state.documentViewer);
  const { documentviewerCurrentPage, documentviewerSearchValue, documentviewerEventKey, documentviewerSelectedDocumentData, episodeIdentifierTopassDocumentViewer } = useSelector((state) => state.documentViewer);
  // const [documentviewerSearchValue, setDocumentviewerSearchValue] = useState("");
  const [documentviewerRowsPerPage, setDocumentviewerRowsPerPage] = useState(5);
  const [filteredDocumentsList, setFilteredDocumentsList] = useState([]);
  // const [eventKey, setEventKey] = useState(null);
  // const [documentPage, setDocumentPage] = useState(1)
  // const [selectedDocumentData, setSelectedDocumentData] = useState({
  //   documentID: null,
  //   documentContent: "",
  //   documentName: "",
  // });

  const toggleAccordion = (id) => { 
    dispatch(setDocumentviewerEventKey(id === documentviewerEventKey ? null : id));
  };

  
  useEffect(() => {
    if (!documentViewerDataError && selectedEpisodeIdentifier !== undefined) {
      dispatch(setEpisodeIdentifierTopassDocumentViewer(selectedEpisodeIdentifier));
      dispatch(resetDocumentviewerSearchValue())
    }
      // console.log('Error occurred, episodeIdentifier reset');

  }, [documentViewerDataError, selectedEpisodeIdentifier, dispatch]);

  useEffect(() => {
    // console.log(episodeIdentifierTopassDocumentViewer, 'im here')
  if(episodeIdentifierTopassDocumentViewer?.length > 0  && documentviewerCurrentPage !== undefined){
      dispatch(getDocumentViewerData({documentEpisodeIdentifier: episodeIdentifierTopassDocumentViewer, documentCurrentPage: documentviewerCurrentPage}));
    }
  }, [episodeIdentifierTopassDocumentViewer]);


  const indexOfLastDocument = documentviewerCurrentPage * documentviewerRowsPerPage;
  const indexOfFirstDocument = indexOfLastDocument - documentviewerRowsPerPage;
  // const currentDocumentsList = documentViewerData?.documents
  // ?.slice(indexOfFirstDocument, indexOfLastDocument) || [];

const totalDocuments = Number(documentViewerData?.total_documents) || 0;
const currentPage = Number(documentviewerCurrentPage);
const rowsPerPage = Number(documentviewerRowsPerPage);
const isValid = Number.isFinite(currentPage) && Number.isFinite(rowsPerPage) && currentPage > 0 && rowsPerPage > 0;
const start = isValid ? (currentPage - 1) * rowsPerPage + 1 : '-';
const end = isValid ? Math.min(currentPage * rowsPerPage, totalDocuments) : '-';

  const totalPages = documentViewerData?.total_documents ? Math.ceil(documentViewerData.total_documents / documentviewerRowsPerPage) : 0;

  const checkCardHeight = (index) => {
    const documentsDocumentCategoryId = filteredDocumentsList?.length > 0 ? filteredDocumentsList?.map((item) => item.document_patient_document_id) : [];
    const minDocumentID  = Math.min(...documentsDocumentCategoryId)
    const maxDocumentID  = Math.max(...documentsDocumentCategoryId)
    const currentCardBody = cardRefs.current[index];
    if (currentCardBody) {
      let scrollPosition = Math.floor(currentCardBody.scrollTop);
      const cardHeight = currentCardBody.clientHeight;
      const cardContentHeight = currentCardBody.scrollHeight;
    if (location.pathname === "/document-viewer" || true) {
      const currentDocumentIndex = documentsDocumentCategoryId.indexOf(index);
      if (scrollPosition + cardHeight >= cardContentHeight - 1) { 
        const newDocumentIndex  = documentsDocumentCategoryId[currentDocumentIndex + 1]
          if (newDocumentIndex >= minDocumentID) {
            // setEventKey(newDocumentIndex);
            dispatch(setDocumentviewerEventKey(newDocumentIndex));
            const selectedData = {
              ...documentviewerSelectedDocumentData,
              documentID: newDocumentIndex,
            }
            dispatch(setDocumentviewerSelectedDocumentData(selectedData))
            // setSelectedDocumentData((prev) => ({
            //   ...prev,
            //   documentID: newDocumentIndex,
            // }));
          }
        } else if (scrollPosition <= 0) {
        const newDocumentPrevIndex  = documentsDocumentCategoryId[currentDocumentIndex - 1]
            // const prevIndex = index + 1;
            if (newDocumentPrevIndex <= maxDocumentID) { 
              // setEventKey(newDocumentPrevIndex);
            dispatch(setDocumentviewerEventKey(newDocumentPrevIndex));
            const selectedData = {
              ...documentviewerSelectedDocumentData,
              documentID: newDocumentPrevIndex,
            }
            dispatch(setDocumentviewerSelectedDocumentData(selectedData))
              // setSelectedDocumentData((prev) => ({
              //   ...prev,
              //   documentID: newDocumentPrevIndex,
              // }));
            }
          }
        }
      } else {
        console.log('No card found');
      }
    };

    useEffect(() => {
      dispatch(setDocumentviewerPage(1));
    }, [])

    useEffect(() => {
      if (documentViewerData !== undefined && documentViewerData.documents !== undefined) {
        setFilteredDocumentsList(documentViewerData.documents)
      }
    }, [documentViewerData]); // Add documentViewerData to dependencies to re-run when it changes
    

  const handleDocumentViewerPageChange = (pageNumber) => {
    const params = new URLSearchParams(window.location.search);
    const getQueryEpisodeIdentifier = params.get("episode_identifier_number");
    if (pageNumber > 0 && pageNumber <= documentViewerData?.total_documents) {
      // setDocumentviewerCurrentPage(pageNumber);
      // const documentEpisodeIdentifier = episodeIdentifierTopassDocumentViewer?.length > 0  && documentviewerCurrentPage !== undefined ? episodeIdentifierTopassDocumentViewer
      // episodeIdentifierTopassDocumentViewer?.length > 0  && documentviewerCurrentPage !== undefined
      const selectedData = {
        ...documentviewerSelectedDocumentData,
        documentID: null,
      }
      // setSelectedDocumentData((prev) => ({
      //   ...prev,
      //   documentID: null,
      // }));
      dispatch(resetDocumentViewerError());
      dispatch(setDocumentviewerEventKey(null));
      dispatch(setDocumentviewerSelectedDocumentData(selectedData));
      dispatch(setDocumentviewerPage(pageNumber));
      if(episodeIdentifierTopassDocumentViewer?.length > 0  && pageNumber !== undefined){
        dispatch(getDocumentViewerData({documentEpisodeIdentifier: episodeIdentifierTopassDocumentViewer, documentCurrentPage: pageNumber}));
      }
    }
  };


  const documentSearchHandler = (event) => {
    // setDocumentviewerSearchValue(event.target.value);
    dispatch(setDocumentviewerSearchValue(event.target.value));
  };

  // const debouncedSearch = useCallback(
  //   debounce(async (query, episodeIdentifier) => {
  //     const params = new URLSearchParams(window.location.search);
  //     const getQueryEpisodeIdentifier = params.get("episode_identifier_number");
      
  //       const payload = { 
  //       episode_identifier: episodeIdentifierTopassDocumentViewer !== undefined ? episodeIdentifierTopassDocumentViewer : episodeIdentifier !== undefined ? episodeIdentifier : getQueryEpisodeIdentifier,
  //       document_name: selectedDocumentData?.documentName ?? "",
  //       search_term: query ?? "",
  //     };
  //   // console.log(payload, 'payload')
  //     // dispatch(searchDocumentViewerData(payload));
  //   }, 200),
  //   [episodeIdentifierTopassDocumentViewer, selectedDocumentData, dispatch]
  // );

  const documentSelectedHandler = (documentData) => {
    const params = new URLSearchParams(window.location.search);
    const newEpisodeIdentifier = params.get("episode_identifier_number");
    
    const episode_identifier_to_pass = episodeIdentifierTopassDocumentViewer
      ? episodeIdentifierTopassDocumentViewer
      : newEpisodeIdentifier;
  
    // Prepare the data to pass
    const data = {
      // documentName: documentData.document_name?.toLowerCase()?.replace(/\.txt/g, ""),
      // documentName: documentData.document_name?.slice(documentData.document_name.indexOf("-") + 1),
      documentName: documentData?.document_name?.replace(".txt", "")?.slice(documentData?.document_name?.indexOf("-") + 1),
      eventKey: documentviewerEventKey,
      searchValue: documentviewerSearchValue,
      episode_identifier_number: episode_identifier_to_pass,
      page: documentviewerCurrentPage,
    };
    sessionStorage.setItem('documentViewerData', JSON.stringify(data));
    window.open('/document-viewer', '_blank');
  
  };
  

  const addTooltipToSpans = (reasoningContent, documentCodes) => {
    return reasoningContent?.replace(/(<span[^>]*>)/g, (text) => {
      return text.replace('<span', `<span data-tooltip=${documentCodes}`);
    });
  };


  const highlightText = (documentText, searchTerm) => {
    // const text = documentText.replace(/\r\n|\r|\n/g, "<br />");
    // if (!searchTerm) return text; 
    // const parts = text.split(new RegExp(`(${searchTerm})`, 'gi')); 
    
    // return parts.map((part, index) =>
    //   part.toLowerCase() === searchTerm.toLowerCase() ? (
    //     <span key={index} style={{ backgroundColor: 'yellow' }}>{part}</span>
    //   ) : (
    //     part
    //   )
    // );

    if (!searchTerm) return documentText;
    const div = document.createElement('div');
    div.innerHTML = documentText;
    const textNodes = (node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        const parts = node.textContent.split(new RegExp(`(${searchTerm})`, 'gi'));
  
        const fragment = document.createDocumentFragment();
        parts.forEach((part, index) => {
          if (part.toLowerCase() === searchTerm.toLowerCase()) {
            const span = document.createElement('span');
            span.style.backgroundColor = 'yellow';
            span.textContent = part;
            fragment.appendChild(span);
          } else {
            fragment.appendChild(document.createTextNode(part));
          }
        });
  
        node.replaceWith(fragment);
      } else {
        node.childNodes.forEach(textNodes);
      }
    };
  
    textNodes(div);
  
    return div.innerHTML;
  };

  const highlightHtmlText = (html, documentData, searchTerm) => {
    let document_codes = documentData.reasonings.map((item) => item.document_codes);
    // let newDocumentCodes = document_codes.reverse();
    // console.log(document_codes, 'document_codes')
    // console.log(newDocumentCodes, 'newDocumentCodes')
    // console.log(document_codes, 'document_codes')
    
    let newStr = html;
    let counter = 0; // A counter to loop through document_codes
    
    const updatedText = newStr.replace(/<span(.*?)style=['"](.*?background-color:.*?)['"](.*?)>/g, (match, p1, p2, p3) => {
      const documentCode = document_codes[counter % document_codes.length];  
      
      counter++;
    
      return `<span${p1} style='${p2}' data-tooltip='${documentCode}' ${p3}>`;
    });
    
    
    if (!searchTerm) return updatedText;
    const div = document.createElement('div');
    div.innerHTML = updatedText;
    const textNodes = (node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        const parts = node.textContent.split(new RegExp(`(${searchTerm})`, 'gi'));
  
        const fragment = document.createDocumentFragment();
        parts.forEach((part, index) => {
          if (part.toLowerCase() === searchTerm.toLowerCase()) {
            const span = document.createElement('span');
            span.style.backgroundColor = 'yellow';
            span.textContent = part;
            fragment.appendChild(span);
          } else {
            fragment.appendChild(document.createTextNode(part));
          }
        });
  
        node.replaceWith(fragment);
      } else {
        node.childNodes.forEach(textNodes);
      }
    };
  
    textNodes(div);
  
    return div.innerHTML;
  };  

  return (
       <div className="document-viewer-section">
        <div className="document-viewer-search">
          <span className="document-viewer-search-icon">
            <img className="document-viewer-search-img" src={searchIcon} />
          </span>
          <input
            className="document-viewer-search-input"
            placeholder="Search"
            autoComplete="off"
            name="documentviewerSearchValue"
            value={documentviewerSearchValue}
            onChange={documentSearchHandler}
          />
        </div>
        <div className="document-viewer-accordion-section">
          {documentViewerDataLoader ? (
            <div className="document-viewer-loader">
              <LdsRoller/>{" "}
            </div>
          ) : documentViewerDataError ? (
            <div className="document-viewer-error">
              <p>{documentViewerDataError}</p>
            </div>
          ) : (
            <Accordion className="document-viewer-accordion-container" activeKey={documentviewerEventKey}> 
              {filteredDocumentsList?.length > 0
               ? (filteredDocumentsList?.map((documentData, index) => (
                  <Card key={documentData.document_patient_document_id} className="document-viewer-accordion-card">
                    <Card.Header className="document-viewer-accordion-header">
                      <div className="document-accordion-section">
                        <div className="document-viewer-btn">
                          {/* {episodeIdentifierTopassDocumentViewer !== undefined
                            && documentData.document_name?.toLowerCase()?.replace(/\.txt/g, "")?.slice(episodeIdentifierTopassDocumentViewer?.length + 1)
                            // : documentData.document_name?.toLowerCase()?.replace(/\.txt/g, "")?.slice(query_episode_identifier_number?.length + 1)
                          } */}
                          {/* {documentData.document_name?.slice(documentData.document_name.indexOf("-") + 1)} */}
                          {documentData?.document_name?.replace(".txt", "")?.slice(documentData?.document_name?.indexOf("-") + 1).replaceAll("_", " ")}
                        </div>
                        <div>
                          {documentviewerEventKey === documentData?.document_patient_document_id ? (
                            <div>
                              <a
                                onClick={(e) => documentSelectedHandler(documentData)}
                                className="externalLink-btn"
                              >
                                <img src={externalIcon} alt="External Link" />
                              </a>
                              <button
                                className="document-accordion-minus-icon"
                                onClick={() => toggleAccordion(documentData?.document_patient_document_id)}
                              >
                                <img src={minsIcon} alt="-" />
                              </button>
                            </div>
                          ) : (
                            <div className="accordion-header-btn">
                              <button
                                className="document-accordion-plus-icon"
                                onClick={() => {
                                  toggleAccordion(documentData?.document_patient_document_id);
                                  const selectedData = {
                                    documentID: documentData?.document_patient_document_id,
                                    documentContent: documentData?.document_text,
                                    // documentName: documentData.document_name?.toLowerCase()?.replace(/\.txt/g, "")?.slice(episodeIdentifierTopassDocumentViewer?.length + 1),
                                    // documentName: documentData.document_name?.slice(documentData.document_name.indexOf("-") + 1),
                                    documentName: documentData?.document_name?.replace(".txt", "")?.slice(documentData?.document_name?.indexOf("-") + 1)
                                  }
                                  dispatch(setDocumentviewerSelectedDocumentData(selectedData))
                                  // setSelectedDocumentData({
                                  //   documentID: documentData?.document_patient_document_id,
                                  //   documentContent: documentData?.document_text,
                                  //   documentName: documentData.document_name?.toLowerCase()?.replace(/\.txt/g, "")?.slice(episodeIdentifierTopassDocumentViewer?.length + 1),
                                  // });
                                }}
                              >
                                <img src={plusIcon} alt="+" />
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </Card.Header>
                    <Accordion.Collapse eventKey={documentData?.document_patient_document_id}>
                      <Card.Body className="document-viewer-accordion-card-body"
                        ref={(el) => (cardRefs.current[documentData?.document_patient_document_id] = el)}
                        onScroll={() => checkCardHeight(documentData?.document_patient_document_id)}
                      >
                       {documentData?.document_coloured_text !== null ? (
                        <div className="document-viewer-accordion-text"
                           dangerouslySetInnerHTML={{
                           __html:DOMPurify.sanitize (highlightHtmlText(
                            // documentData?.document_coloured_text.replace(/\n/g, "<br />"),
                            documentData?.document_coloured_text.replace(/\r\n|\r|\n/g, "<br />"),
                            documentData,
                            documentviewerSearchValue
                          )),
                        }}
                      />
                      ) : (
                  <div className="document-viewer-accordion-text">
                    <span 
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(highlightText(documentData?.document_text.replace(/\r\n|\r|\n/g, "<br />"), documentviewerSearchValue))
                    }}
                    ></span>
                  </div>
                )}

                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                ))
              ) : (
                 <p className="document-no-data-found">No matching documents found.</p>
              )}
            </Accordion>
          )}
          {/* Reasoning Accordion */}
         {/* {!documentViewerDataLoader &&  filteredDocumentsList?.length > 0 &&  <Accordion className="document-viewer-accordion-reasoning-container" activeKey={documentviewerEventKey}>
                <Card className="document-viewer-accordion-reasoning-card">
                  <Card.Header className="document-viewer-accordion-reasoning-header">
                    <div className="document-accordion-section">
       
                      <div>
                        {documentviewerEventKey !== null &&
                        documentviewerEventKey === documentviewerSelectedDocumentData.documentID ? (
                          <div>

                            <button
                              className="document-accordion-minus-icon"
                              onClick={() =>
                                toggleAccordion(documentviewerSelectedDocumentData.documentID)
                              }
                            >
                              <img src={minsIcon} alt="-" />
                            </button>
                          </div>
                        ) : (
                          <div className="accordion-header-btn">
                            <button
                              className="document-accordion-plus-icon"
                              onClick={() => {
                                toggleAccordion(
                                  documentviewerSelectedDocumentData.documentID
                                );
                              }}
                            >
                              <img src={plusIcon} alt="+" />
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </Card.Header>
                  {documentviewerEventKey !== null && (
                    <Accordion.Collapse
                    eventKey={documentviewerSelectedDocumentData.documentID}
                    >
                      <Card.Body className="document-viewer-accordion-reasoning-card-body">
  
                        {filteredDocumentsList
                          .filter(
                            (item) =>
                              item.document_patient_document_id ===
                            documentviewerSelectedDocumentData.documentID
                          )
                          .map((item) =>
                            item.reasonings.length > 0 ? item.reasonings.map((reasoningsData) => (
                              <>
                                <span className="document-viewer-reasoning-name">
                                  {reasoningsData.group}:
                                </span>
                                <div key={reasoningsData?.reasoning_id}>
                                  <div
                                    className="document-viewer-reasoning-text"
                                    dangerouslySetInnerHTML={{
                                      __html: addTooltipToSpans(
                                        reasoningsData
                                          .document_coloured_reasoning_content
                                          ?.length > 0
                                          ? reasoningsData.document_coloured_reasoning_content
                                          : reasoningsData.document_reasoning_content, reasoningsData.document_codes
                                      ),
                                    }}
                                  />
                                </div>
                              </>
                            ))
                            : <p className="document-viewer-reasoning-text-no-data">No reasonings found</p>)}
                      </Card.Body>
                    </Accordion.Collapse>
                  )}
                </Card>
              </Accordion>} */}
        </div>
          <Pagination className="document-viewer-pagination">
            <Pagination.Prev
              onClick={() => handleDocumentViewerPageChange(documentviewerCurrentPage - 1)} disabled={documentviewerCurrentPage === 1}
            className="document-viewe-prev-btn"
            />
            {`Showing ${start} - ${end} of ${totalDocuments}`}
            {/* {`showing ${start}- ${end ? end : 0} of ${documentViewerData?.total_documents > 0 ? documentViewerData?.total_documents : 0}`} */}
            {/* {documentViewerData?.total_documents > 5 && `showing ${documentviewerCurrentPage}-${} of ${totalPages}`} */}
            <Pagination.Next
            onClick={() => handleDocumentViewerPageChange(documentviewerCurrentPage + 1)} disabled={documentviewerCurrentPage === totalPages || totalPages === 0}
            // onClick={() => handleDocumentViewerPageChange(documentviewerCurrentPage + 1)}  disabled={documentviewerCurrentPage === 1 || documentviewerCurrentPage === totalPages || totalPages === 0}
            className="document-viewe-next-btn"
            />
          </Pagination>
      </div>
  );
};

export default DocumentViewer;
